import React from 'react';
import PropTypes from 'prop-types';
import { SignUpModal } from '@strava/authentication-ui';
import Microfrontend from '../../../../Microfrontend';
import StravaPackageContextProviders from '../../../../StravaPackageContextProviders';

const SignUpModalWrapper = ({ url, useMfe, ...props }) => {
  if (useMfe)
    return (
      <Microfrontend
        url={url}
        scope="strava_sign_up_modal_development"
        component="./App"
        appContext={props}
      />
    );

  return (
    <StravaPackageContextProviders>
      <SignUpModal {...props} />
    </StravaPackageContextProviders>
  );
};

SignUpModalWrapper.propTypes = {
  useMfe: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  authorizationUrls: PropTypes.shape({
    google: PropTypes.string,
    facebook: PropTypes.string,
    email: PropTypes.string
  }).isRequired,
  appleState: PropTypes.string.isRequired
};

export default SignUpModalWrapper;
